import { Context, createContext } from 'react';

import { BasketSidePanelContextState } from '../interfaces';

export const BasketSidePanelContext: Context<BasketSidePanelContextState> = createContext<BasketSidePanelContextState>({
  isBasketSidePanelOpen: false, setIsBasketSidePanelOpen: (): void => undefined,
});
